'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markImageAsLoaded = undefined;

var _progressiveImageConstants = require('./progressiveImageConstants');

/**
 * Marks an image as loaded so that the Progressive image will not attempt to show the thumbnail.
 *
 * @param source {String} The source URL of the image that has been loaded.
 */
var markImageAsLoaded = exports.markImageAsLoaded = function markImageAsLoaded(_ref) {
  var source = _ref.source;
  return {
    type: _progressiveImageConstants.IMAGE_LOADED,
    source: source
  };
}; // Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/progressiveImages/progressiveImageActions.js
// module id = 1904
// module chunks = 0